export default "__VITE_ASSET__BgQd1Grv__"